import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useChartSeriesVisibility } from '@web/utility/hooks/useChartSeriesVisibility';
export function ChartSeriesVisibility(_a) {
    var seriesKeys = _a.seriesKeys, mode = _a.mode, children = _a.children;
    var controller = useChartSeriesVisibility(seriesKeys, { mode: mode });
    return _jsx(_Fragment, { children: children(controller) });
}
